<template>
  <div class="expand-collapse">
    <p :style="{ '--line': lineClamp }" class="line-clamp text-justified" v-html="content"></p>
    <i v-if="showBtn" @click.stop="handleUpdateStyle">
      {{ unflod ? '展开更多 >>>' : '收起' }}
    </i>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    lineClamp: {
      type: Number | String,
      default: 4
    }
  },
  data() {
    return {
      showBtn: false,
      unflod: true
    }
  },
  watch: {
    content: {
      handler() {
        this.initHeight()
      },
      deep: true
    }
  },
  mounted() {
    this.initHeight()
  },
  methods: {
    // 初始化高度判断
    initHeight() {
      this.$nextTick(() => {
        const { scrollHeight, offsetHeight } = this.$el.querySelector('p')
        this.showBtn = scrollHeight > offsetHeight
      })
    },

    // 展开|收起
    handleUpdateStyle() {
      const hasAttr = this.$el.querySelector('p').getAttribute('class').includes('line-clamp')
      this.$el.querySelector('p').classList[hasAttr ? 'remove' : 'add']('line-clamp')
      this.unflod = !hasAttr
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.line-clamp {
  --line: 4;
  display: -webkit-box;
  -webkit-line-clamp: var(--line);
  -webkit-box-orient: vertical;
  overflow: hidden;
}

i {
  //position: absolute;
  //right: 0;
  //bottom: 0;
  //padding: 0 0 0 70px;
  //line-height: 40px;
  //background: linear-gradient(to right, rgba(255, 255, 255, 0.7) 2%, #fff calc(11% + 50px));
  font-style: normal;
  color: #4d7cfe;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ExpandAndCollapse/index.vue